import type { Props } from './Svg'
import { Svg } from './Svg'

export function ArrowLeftIcon(props: Props) {
  return (
    <Svg width="19" height="16" fill="currentColor" stroke="none" {...props}>
      <path d="M18.4 7H3.8l5.3-5.3L7.7.3 0 8l7.7 7.7 1.4-1.4L3.8 9h14.6V7Z" />
    </Svg>
  )
}
